<template>
  <v-container class="page-content-wrapper pa-0 px-sm-3">
    <h1 class="headline pa-3 px-sm-5">Static data</h1>
    <div class="d-flex">
      <v-card class="mx-4">
        <v-card-title> Payment status </v-card-title>
        <v-card-text class="d-flex">
          <v-data-table
            :headers="statusHeaders"
            :items="statusItems"
            item-key="id"
            fixed-header
            hide-default-footer
            disable-sort
            disable-pagination
          >
            <template #item.icon="{ item }">
              <v-tooltip top color="primary">
                <template #activator="{ on }">
                  <v-icon
                    v-if="item.icon.icon"
                    :color="item.icon.color"
                    v-on="on"
                    >${{ item.icon.icon }}</v-icon
                  >
                </template>
                <span>{{ $t(item.key) }}</span>
              </v-tooltip>
            </template>
            <template #item.key="{ item }">
              <span>{{ $t(item.key) }}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <v-card class="mx-4">
        <v-card-title> Payment types </v-card-title>
        <v-card-text class="d-flex">
          <v-data-table
            :headers="typesHeaders"
            :items="typesItems"
            item-key="id"
            fixed-header
            hide-default-footer
            disable-sort
            disable-pagination
          >
            <template #item.key="{ item }">
              <span>{{ $t(item.key) }}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <v-card class="mx-4">
        <v-card-title> Email status</v-card-title>
        <v-card-text class="d-flex">
          <v-data-table
            :headers="statusHeaders"
            :items="emailStatusItems"
            item-key="id"
            fixed-header
            hide-default-footer
            disable-sort
            disable-pagination
          >
            <template #item.icon="{ item }">
              <v-tooltip top color="primary">
                <template #activator="{ on }">
                  <v-icon
                    v-if="item.icon.icon"
                    :color="item.icon.color"
                    v-on="on"
                    >${{ item.icon.icon }}</v-icon
                  >
                </template>
                <span>{{ $t(item.key) }}</span>
              </v-tooltip>
            </template>
            <template #item.key="{ item }">
              <span>{{ $t(item.key) }}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <!-- <v-card class="mx-2 mb-4">
        <v-card flat>
          <v-card-title> Icons </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="iconsHeaders"
              :items="iconItems"
              item-key="key"
              fixed-header
              hide-default-footer
              disable-sort
              disable-pagination
            >
              <template #item.icon="{ item }">
                <v-icon color="primary">{{ item.icon }}</v-icon>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card> -->
    </div>
  </v-container>
</template>

<script>
import {
  paymentStatusStates,
  paymentTypes,
  emailStatusStates,
} from "@/static/staticData";

//import { icons } from "@/static/icons";

export default {
  title: "Static data",
  name: "StaticData",
  data() {
    return {
      statusHeaders: [
        { text: "Id", value: "id", divider: true, width: 100 },
        {
          text: "Icon",
          value: "icon",
          divider: true,
          width: 100,
        },
        { text: "Text", value: "key", divider: true },
      ],
      statusItems: paymentStatusStates.concat([
        {
          id: "other",
          key: "unknown",
          icon: { icon: "$help", color: "error" },
        },
      ]),
      typesHeaders: [
        { text: "Id", value: "id", divider: true, width: 100 },
        { text: "Text", value: "key", divider: true },
      ],
      typesItems: paymentTypes.concat([
        {
          id: "other",
          key: "undefined",
        },
      ]),
      emailStatusItems: emailStatusStates,
      // iconsHeaders: [
      //   { text: "name", value: "key", divider: true },
      //   { text: "icon", value: "icon", divider: true },
      // ],
      // iconItems: Object.keys(icons).map((key) => {
      //   return { key: key, icon: `$${key}` };
      // }),
    };
  },
};
</script>
